import { render, staticRenderFns } from "./AdmittedPremium3Table.vue?vue&type=template&id=b9fe1fec&scoped=true&"
import script from "./AdmittedPremium3Table.vue?vue&type=script&lang=js&"
export * from "./AdmittedPremium3Table.vue?vue&type=script&lang=js&"
import style0 from "./AdmittedPremium3Table.vue?vue&type=style&index=0&id=b9fe1fec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fe1fec",
  null
  
)

export default component.exports